import { Injectable } from '@angular/core';
import {EliteFormManagerService} from "@features/elite-form/services/elite-form-manager.service";

@Injectable({
  providedIn: 'root'
})
export class EliteFormServiceFactory {
  private eliteFormServiceDict: Map<string, EliteFormManagerService>;
  constructor() {
    this.eliteFormServiceDict = new Map<string, EliteFormManagerService>();
  }
  getEliteFormManagerService(eliteFormId: string): EliteFormManagerService{
    if (this.eliteFormServiceDict.has(eliteFormId)) {
      return this.eliteFormServiceDict.get(eliteFormId);
    }
    this.eliteFormServiceDict.set(eliteFormId, new EliteFormManagerService());
    return this.eliteFormServiceDict.get(eliteFormId);
  }
  registerEliteFormResponseService(eliteFormId: string, eliteFormDesignService: EliteFormManagerService): void{
    this.eliteFormServiceDict.set(eliteFormId, eliteFormDesignService);
  }
  destroyService(eliteFormId: string) {
    if (this.eliteFormServiceDict.has(eliteFormId)){
      this.eliteFormServiceDict.get(eliteFormId).destroy();
      this.eliteFormServiceDict.delete(eliteFormId);
    }
  }
  destroy() {
    for (let eliteFormDesignService of this.eliteFormServiceDict.values()) {
      eliteFormDesignService.destroy();
    }
    this.eliteFormServiceDict.clear();
  }
}
